// Configuración de animaciones Rive
export const RIVE_ANIMATIONS = {
  // Animaciones de login
  LOGIN_SUCCESS: "/animations/galilea_logo_animation_-_final.riv",
  LOGIN_SUCCESS_SMALL: "/animations/galilea_logo_animation_-_small_mobile.riv",
  LOGIN_LOADING: "/animations/galilea_loading_animation.riv",

  // Animaciones de dashboard
  DASHBOARD_WELCOME: "/animations/dashboard-welcome.riv",
  INVESTMENT_GROWTH: "/animations/investment-growth.riv",

  // Animaciones de carga
  LOADING_SPINNER: "/animations/loading-spinner.riv",
  DATA_LOADING: "/animations/data-loading.riv",

  // Animaciones de estado
  SUCCESS: "/animations/success.riv",
  ERROR: "/animations/error.riv",
  WARNING: "/animations/warning.riv",

  // Animaciones de transición
  PAGE_TRANSITION: "/animations/page-transition.riv",
};

// Configuración por defecto para animaciones
export const DEFAULT_ANIMATION_CONFIG = {
  autoplay: true,
  loop: true,
  fit: "cover",
  alignment: "center",
};

// Configuración específica para móvil
export const MOBILE_ANIMATION_CONFIG = {
  autoplay: true,
  loop: true,
  fit: "cover",
  alignment: "center",
};

// Duraciones estándar
export const ANIMATION_DURATIONS = {
  SHORT: 1000,
  MEDIUM: 2000,
  LONG: 3000,
  EXTRA_LONG: 5000,
  LOGIN_SUCCESS: 8500,
  TRANSITION: 900,
};

// Breakpoints para detección de dispositivos
export const DEVICE_BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1200,
};
